import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {createSection} from 'src/openapi/admin/apis/ConferenceSectionsApi';
import {SectionIconType as SectionIconTypes} from 'src/openapi/admin/models/SectionIconType';
import {SectionType as SectionTypes} from 'src/openapi/admin/models/SectionType';
import {useAppDispatch} from 'src/store/hooks';

import type {SectionRequest} from 'src/openapi/admin/models/SectionRequest';
import type {SuccessPayload} from 'src/typedef';

type Props = {
    sectionsCount: number,
    conferenceId: number,
};

const DEFAULT_FORM: SectionRequest = {
    conferenceId: 0,
    sectionType: SectionTypes.CUSTOM,
    sectionName: '',
    iconType: SectionIconTypes.AGENDA,
    webVersionEnabled: false,
    mobileVersionEnabled: false,
    order: 0,
};

export const useCreateSection = ({sectionsCount, conferenceId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => {
        return Promise.resolve({type: '', payload: {
            success: true,
            error: false,
            data: {...DEFAULT_FORM, order: sectionsCount + 1, conferenceId},
        } as SuccessPayload<SectionRequest>});
    }, [sectionsCount, conferenceId]);

    const saveDispatchAction = useCallback((sectionRequest: SectionRequest, signal: AbortSignal) => apiDispatch(
        createSection({sectionRequest}, {signal}),
    ), [apiDispatch]);

    return useCommonDataHook({
        initValue: DEFAULT_FORM,
        getDispatchAction,
        saveDispatchAction,
    });
};
